<template>
  <div id="gwi-voucherAdd" class="app bg-gray">
    <div class="scroll">
      <form class="gwi-form" action="" @submit.prevent="submitForm">
        <section>
          <!-- 第一行，文字提醒行，没有下划线 -->
          <div class="voucher-add-des">
            <p
              v-if="currentSelectCardType.key === '01'"
              class="voucher-add-des-content f-normal"
            >
              填写电子健康卡信息
            </p>
            <p
              v-else-if="currentSelectCardType.key === '4'"
              class="voucher-add-des-content f-normal"
            >
              填写居民健康卡信息
            </p>
            <p v-else="" class="voucher-add-des-content f-normal">
              请填写就诊凭证信息
            </p>
          </div>
          <ul class="list">
            <!-- 卡类型 -->
            <li class="ipt-item">
              <TypeSelect
                @type-select="selectCardType"
                labelName="卡类型"
                :typeList="cardTypeList"
              ></TypeSelect>
            </li>
            <!-- 姓名 -->
            <li class="ipt-item flex-row flex-align-center">
              <span class="f-normal voucher-add-item-left">您的姓名</span>
              <input
                type="text"
                class="gwi-ipt my-ipt flex-1"
                v-model="userName"
                placeholder="请输入姓名"
                maxlength="20"
              />
            </li>
            <!-- 卡号 -->
            <li class="ipt-item flex-row flex-align-center">
              <span class="f-normal voucher-add-item-left">{{
                currentSelectCardType.key === "01" ? "身份证号" : "卡号"
              }}</span>
              <input
                type="text"
                class="gwi-ipt my-ipt flex-1"
                v-model="cardNo"
                :placeholder="
                  currentSelectCardType.key === '4'
                    ? '请输入居民健康卡号'
                    : '请输入身份证号'
                "
                maxlength="20"
              />
            </li>
          </ul>
        </section>
        <!-- 提醒区域 -->
        <div class="voucher-add-bottom-tips">
          <p class="f-strongest">请务必填写真实的身份信息，否则可能无法就诊</p>
        </div>
        <section class="voucher-add-footer box">
          <button
            id="voucherAdd-btn-submit"
            class="btn-ok"
            type="button"
            @click="submitForm"
          >
            绑定就诊凭证
          </button>
        </section>
      </form>
    </div>
  </div>
</template>
<script>
import utils from 'utils'
import voucherService from 'voucher.service'
import TypeSelect from 'TypeSelect'
const checkForm = function (data) {
  // 卡类型效验
  if (!data.currentSelectCardType.key) {
    return '请先选择要绑定的卡类型';
  }
  if (data.userName === null || data.userName.trim().length === 0) {
    return '请输入您的姓名';
  }
  const cardTypeName = data.currentSelectCardType.key === '01' ? '身份证号' : '卡号'
  if (data.cardNo.length === 0) {
    return cardTypeName + '不能为空';
  }
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (data.cardNo === null || !(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(data.cardNo.toUpperCase()))) {
    return cardTypeName + '输入有误';
  }
}
export default {
  components: {
    TypeSelect
  },
  mounted () {

  },
  methods: {
    submitForm () {
      let errorMsg = checkForm(this);
      if (errorMsg) {
        return utils.alert(errorMsg);
      }
      // 拼接请求参数 姓名+卡号+卡类型
      const queryStr = this.userName + '&' + this.cardNo + '&' + this.currentSelectCardType.key;
      voucherService.addVoucher({
        cardType: this.currentSelectCardType.key,
        queryStr: queryStr
      }).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          utils.alert(res.resultMsg)
          return
        }
        utils.alert('绑卡成功！')
        // 退后两步以返回到办卡之前
        // 如果是从工作号菜单跳转来办卡绑卡的，回到主菜单
        if (this.$store.state.paramModule.param.voucherChooseType.isFromWechatMenu) {
          this.$store.commit('changeState', 'Home');
          this.$router.replace('/')
        } else {
          this.$router.go(-2)
        }
      })
    },
    selectCardType (index) {
      this.currentSelectCardType = this.cardTypeList[index]
    },
  },
  data () {
    return {
      cardTypeList: [
        //{ key: '01', name: '电子健康卡' },
        { key: '4', name: '居民健康卡' }
      ],
      userName: '',
      cardNo: '',
      currentSelectCardType: {},
    }
  }
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";
.voucher-add-item-left {
  width: 25%;
}
.voucher-add-des {
  padding: 0.25rem 0.75rem;
  .voucher-add-des-content {
    height: $common-input-height;
    line-height: $common-input-height;
  }
}
.voucher-add-bottom-tips {
  margin: 0 15px;
}
.voucher-add-footer {
  margin-top: 15px;
}
.my-ipt {
  font-size: 0.45rem !important;
}
</style>


// WEBPACK FOOTER //
// VoucherAdd.vue?756ee129